var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9734 5.10713L8.74416 4.64147L7.25375 1.65206C7.20776 1.55903 7.1123 1.5 7.0076 1.5C6.90299 1.5 6.80752 1.55903 6.76153 1.65206L5.2618 4.64147L2.02777 5.10134C1.94752 5.11281 1.87457 5.15363 1.82324 5.21571C1.7719 5.27786 1.74591 5.35678 1.75052 5.4369C1.75506 5.5171 1.78979 5.59265 1.84785 5.64862L4.19264 7.91265L3.63662 11.1573C3.6244 11.2296 3.63994 11.3039 3.68018 11.3655C3.72035 11.4271 3.78237 11.4716 3.85395 11.4903C3.92552 11.509 4.00164 11.5005 4.06722 11.4666L7.00276 9.93507L9.94411 11.4666C10.0095 11.4985 10.0844 11.5054 10.1546 11.4862C10.2248 11.4669 10.2855 11.4227 10.325 11.3621C10.3645 11.3015 10.3802 11.2286 10.369 11.1573L9.81294 7.91265L12.1532 5.65335C12.2107 5.59721 12.2452 5.5219 12.2495 5.44202C12.2539 5.36213 12.228 5.28346 12.1769 5.22155C12.1258 5.15963 12.0532 5.11881 11.9733 5.10718L11.9734 5.10713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.75aa987621b2bda0fe99ce12b43f2779.svg";
export { ForwardRef as ReactComponent };